import { apiSlice } from "../../app/api/apiSlice";

export const lockRequestApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		lockRequest: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/lock_request/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useLockRequestMutation } = lockRequestApiSlice;
